import React, { useState } from 'react';
import { Check, Copy, Link2 } from 'lucide-react';
import { Modal } from './TicketingShell';

const targets = (url, text) => [
  ['WhatsApp', `https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`, '#25D366'],
  ['LinkedIn', `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`, '#0A66C2'],
  ['X', `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`, '#111111'],
  ['Facebook', `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, '#1877F2'],
];

const ShareModal = ({ open, onClose, url, title }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (_) { /* clipboard blocked */ }
  };
  return (
    <Modal open={open} onClose={onClose} title="Share this event">
      <p className="mb-3 text-sm text-gray-600">Share this link via</p>
      <div className="mb-6 flex flex-wrap gap-3">
        {targets(url, title).map(([name, href, color]) => (
          <a key={name} href={href} target="_blank" rel="noreferrer" className="rounded-xl border px-4 py-2 text-sm font-semibold hover:bg-gray-50" style={{ color }}>
            {name}
          </a>
        ))}
      </div>
      <p className="mb-2 text-sm text-gray-600">Copy link</p>
      <div className="flex overflow-hidden rounded-xl border">
        <span className="flex min-w-0 flex-1 items-center gap-2 px-3 text-sm">
          <Link2 className="h-4 w-4 shrink-0 text-gray-400" />
          <span className="truncate">{url}</span>
        </span>
        <button type="button" onClick={copy} className="flex items-center gap-1 bg-gray-900 px-4 py-2.5 text-sm font-medium text-white">
          {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>
    </Modal>
  );
};

export default ShareModal;
